import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports-management',
  templateUrl: './reports-management.component.html',
  styleUrls: ['./reports-management.component.scss']
})
export class ReportsManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
